import React, { PropTypes } from 'react';
import { StickyContainer } from 'react-sticky';

import { routerContextShape } from '../../proptypes';

import Footer from '../Footer';
import Header from '../Header';
import LoginPrompt from '../LoginPrompt';
import Meta from '../Meta';

import { main, mainOffset, whiteBg } from './styles.module.css';

/**
 * Page layout presentational component, including header and footer.
 */
const Layout = ({ children, routes }) => {
  // Some routes have additional props applied by the routes configuration
  // The last element of the routes array is the final 'resolved' route
  const routeProps = routes && routes.slice(-1).pop();
  const { noBanner, noFooter, transparentHeader, whiteBackground } = routeProps || {};
  return (
    <div className={whiteBackground ? whiteBg : null}>
      <Meta />
      <StickyContainer>
        <LoginPrompt noBanner={noBanner} />
        <Header transparent={transparentHeader} />
        <main className={transparentHeader ? mainOffset : main}>
          {children}
        </main>
        {!noFooter &&
        <Footer />}
      </StickyContainer>
    </div>
  );
};

Layout.propTypes = {
  /**
   * Children contents of main container within layout.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  /**
   * Routes context props, see proptypes.
   */
  routes: routerContextShape.routes,
};

Layout.defaultProps = {
  children: [],
  routes: undefined,
};

export default Layout;



// WEBPACK FOOTER //
// ./app/src/components/Layout/index.jsx